export function createAppModalState(adminOpen = false) {
  return {
    currencyOpen: false,
    settingsOpen: false,
    sectionsOpen: false,
    adminOpen: Boolean(adminOpen),
  };
}

export function appModalReducer(state, action) {
  switch (action.type) {
    case "OPEN_ADMIN":
      return { ...createAppModalState(true) };
    case "CLOSE_ADMIN":
      return { ...state, adminOpen: false };
    case "OPEN_CURRENCY":
      return state.adminOpen ? state : { ...state, currencyOpen: true };
    case "CLOSE_CURRENCY":
      return { ...state, currencyOpen: false };
    case "OPEN_SETTINGS":
      return state.adminOpen ? state : { ...state, settingsOpen: true };
    case "CLOSE_SETTINGS":
      return { ...state, settingsOpen: false };
    case "OPEN_SECTIONS":
      return state.adminOpen ? state : { ...state, sectionsOpen: true };
    case "CLOSE_SECTIONS":
      return { ...state, sectionsOpen: false };
    default:
      return state;
  }
}
